import React, { useState } from "react"
import { Info, PictureAsPdf } from "@mui/icons-material"
import { Box, Grid, Stack, Tooltip, Typography } from "@mui/material"
import CommonModal from "components/CommonModal"
import { UploadFieldContainer } from "components/FileUpload/components/FieldContainer"
import AppButton from "components/StyledComponents/AppButton"
import StyledLabel from "components/StyledComponents/StyledLabel"
import CommonDragAndDrop from "components/CommonDragAndDrop"
import RedCloseIcon from "assets/icons/RedCloseIcon.svg"
import { bytesToSize } from "helpers/functions"
import { useDispatch } from "react-redux"
import { uploadImageAction } from "redux/hotel/action"
import { getValueByPath } from "../restaurantFormUtils"

const UploadPdfField = ({
  title,
  fieldPath,
  formik,
  isToolTip,
  renderToolTip,
  isRequired,
  placeholder,
  ...props
}) => {
  const [openUploadModal, setOpenUploadModal] = useState(false)
  const [selectedFile, setSelectedFile] = useState(null)
  const uploadedFile = getValueByPath(formik?.values, fieldPath)
  const dispatch = useDispatch()

  const handleOpenUploadModal = () => {
    setOpenUploadModal(true)
  }

  const handleCloseUploadModal = () => {
    setOpenUploadModal(false)
    setSelectedFile(null)
  }
  const viewImage = () => {
    const url = uploadedFile?.url || URL.createObjectURL(uploadedFile)
    const newWindow = window.open(url, "_blank", "noopener,noreferrer")
    if (newWindow) newWindow.opener = null
  }

  const onDelete = () => {
    setSelectedFile(null)
    formik?.setFieldValue(fieldPath, null)
  }

  const showImage = () => {
    return (
      <Box className="d-flex w-100 h-100 imageDataContainer">
        <Box className="imageDataContainerInner flex-grow-1 flex-shrink-1" onClick={viewImage}>
          <Stack direction="row" gap={2} alignItems="center">
            <PictureAsPdf />
            {uploadedFile?.url || uploadedFile?.name ? (
              <Stack>
                <Typography variant="body2Regular">
                  {uploadedFile?.name ?? uploadedFile?.url}
                </Typography>

                {uploadedFile?.size ? (
                  <Typography variant="tag1" sx={{ color: "#ADB5BD" }}>
                    {bytesToSize(uploadedFile?.size)}
                  </Typography>
                ) : null}
              </Stack>
            ) : null}
          </Stack>
        </Box>
        <img
          className="flex-shrink-0"
          role="button"
          src={RedCloseIcon}
          onClick={onDelete}
          alt=""
          style={{ width: 20 }}
        />
      </Box>
    )
  }

  return (
    <Grid container {...props}>
      {title ? (
        <StyledLabel variant="body1Regular">
          {title}
          {isToolTip && (
            <Tooltip title={renderToolTip}>
              <Info className="ms-1" fontSize="small"></Info>
            </Tooltip>
          )}
          {isRequired ? <span>*</span> : null}
        </StyledLabel>
      ) : null}
      <Grid item xs={12}>
        <UploadFieldContainer>
          <Box className="d-flex w-100 h-100 noImageDataContainer  justify-content-end">
            <Box className="d-flex" width="100%" sx={{ justifyContent: "flex-end" }}>
              {uploadedFile ? (
                showImage()
              ) : (
                <>
                  <Box className="placeholder">{placeholder}</Box>
                  <AppButton onClick={handleOpenUploadModal}>Upload</AppButton>
                </>
              )}
            </Box>
          </Box>
        </UploadFieldContainer>
      </Grid>
      <CommonModal
        open={openUploadModal}
        onClose={handleCloseUploadModal}
        hideAction={selectedFile ? false : true}
        actionButtons={
          selectedFile ? (
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
              <AppButton onClick={() => setSelectedFile(null)}>Replace</AppButton>
              <AppButton
                onClick={() => {
                  let data = new FormData()
                  data.append("media", selectedFile)
                  data.append("media_type", "IMAGE")
                  data.append("content_type", "OTHER")
                  formik?.setFieldValue(fieldPath, selectedFile)
                  dispatch(uploadImageAction({ data, type: "pdf" }))

                  handleCloseUploadModal()
                }}>
                Submit
              </AppButton>
            </Box>
          ) : null
        }>
        <Box sx={{ padding: "20px", height: "100%" }}>
          <Typography variant="h2" textAlign="center">
            Import Floor Plan PDF
          </Typography>
          <Box width={selectedFile ? "90%" : "70%"} margin="0 auto" mt={2}>
            <CommonDragAndDrop
              setDisable={() => {}}
              type="PDF"
              setAllFilesSelected={() => {}}
              onChange={(url) => {
                setSelectedFile(url)
              }}
              accept=".pdf"
              preview={true}
              selectedFile={selectedFile}
              setSelectedFile={setSelectedFile}
            />
          </Box>
        </Box>
      </CommonModal>
    </Grid>
  )
}

export default UploadPdfField
